import React from "react";
import { Link } from "react-router-dom";
import cImg1 from "../../images/category/img-1.jpg";
import cImg2 from "../../images/category/img-2.jpg";

interface CategoryItem {
  sImg: string;
  title: string;
  sub: string;
  direction: string;
}

const CategoryData: CategoryItem[] = [
  {
    sImg: cImg1,
    title: "Limited Products",
    sub: "We have Just Few Products For You Hurry Up",
    direction: "fadeInLeftSlow",
  },
  {
    sImg: cImg2,
    title: "Trending Products",
    sub: "Here is Our Latest Collection",
    direction: "fadeInRightSlow",
  },
];

const ClickHandler = (): void => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Categorys: React.FC = () => {
  return (
    <section className="wpo-category-section">
      <div className="container-fluid">
        <div className="wpo-category-wrap">
          <div className="row">
            {CategoryData.map((cat, index) => (
              <div className="col-md-6 col-sm-12 col-12" key={index}>
                <div
                  className={`wpo-category-item wow ${cat.direction}`}
                  data-wow-duration="1000ms"
                >
                  <div className="wpo-category-img">
                    <img src={cat.sImg} alt={cat.title} />
                  </div>
                  <div
                    className="wpo-category-text wow fadeInUp"
                    data-wow-duration="1600ms"
                  >
                    <h3>
                      <Link onClick={ClickHandler} to="/shop">
                        {cat.title}
                      </Link>
                    </h3>
                    <p>{cat.sub}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categorys;
